import {
  ButtonBase,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  Paper,
  Skeleton,
  styled as muiStyled,
} from '@mui/material'
import styled, { keyframes } from 'styled-components'
// LS: Live session

export const LSPageParentContainer = styled.div`
  height: 100vh;
  font-family: Outfit;
  width: 100%;
  background: #fff;
  display: ${(props) => (props?.sessionStarted ? 'flex' : 'block')};
  flex-direction: column;
  padding: 0px;
  gap: ${(props) => (props?.sessionStarted ? '0' : '10px')};
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 10px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(67, 56, 202, 0.05);
    border-radius: 5px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(67, 56, 202, 0.3);
    border-radius: 5px;
    
    &:hover {
      background: rgba(67, 56, 202, 0.5);
    }
  }
  
  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(67, 56, 202, 0.3) rgba(67, 56, 202, 0.05);
`
export const LSPageParentContainerV2 = styled.div`
  height: 100vh;
  font-family: Outfit;
  width: 100%;
  background: #fff;
  position: sticky;
  top: 0px;
  padding: ${(props) => (props?.sessionStarted ? '0' : '10px')};
  gap: ${(props) => (props?.sessionStarted ? '0' : '10px')};
`

export const LSPageHeaderTitle = styled.div`
  color: #373737;
  font-family: Outfit;
  font-size: ${(props) => (props?.main ? '20px' : '14px')};
  font-style: normal;
  font-weight: ${(props) => (props?.main ? '500' : '300')};
  line-height: normal;
  @media (min-width: 768px) {
    font-size: ${(props) => (props?.main ? '26px' : '18px')};
    font-style: normal;
    font-weight: ${(props) => (props?.main ? '500' : '300')};
  }
`

export const LSPageContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  flex-grow: 1;
  display: flex;
  gap: 20px;
  margin-top: 60px;
  ${(props) => !props?.sessionStarted ? 'flex-direction: column;' : ''}
  ${(props) => !props?.sessionStarted ? 'min-height: auto;' : ''}
  overflow-x: visible;
  overflow-y: auto;
  box-sizing: border-box;
  @media (max-width: 768px) {
    gap: 0;
    width: 100vw;
    max-width: 100vw;
  }
  @media print {
    margin-top: 0px;
    padding-top: 0px !important;
  }
`

export const LSVideoPartContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow: ${(props) => (props?.sessionStarted ? 'hidden' : 'visible')};
  overflow-x: visible;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: ${(props) => (props?.sessionStarted ? 'center' : 'flex-start')};
  background: ${(props) => (props?.sessionStarted ? '#202124' : '#effeff')};
  border-radius: ${(props) => (props?.sessionStarted ? '0' : '7px')};
  box-sizing: border-box;
  @media (max-width: 768px) {
    width: 100vw;
    max-width: 100vw;
    overflow-x: visible;
    overflow-y: auto;
  }
  @media print {
    height: 100% !important;
  }
`

export const LSVideoPartHeader = muiStyled('div')(
  ({ theme }) => `
  min-height: 64px;
  width: 100%;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.98) 0%, rgba(118, 75, 162, 0.98) 100%);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 24px rgba(102, 126, 234, 0.25), 0 2px 8px rgba(118, 75, 162, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1001;
  color: #ffffff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    padding: 8px 16px;
    min-height: 56px;
  }
  
  @media print {
    display: none;
  }
`,
)

export const LSVideoPartHeaderHeading = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 0.01em;
  
  @media (max-width: 768px) {
    font-size: 13px;
  }
`

export const LSVideoPartHeaderButton = styled.button`
  padding: 2px 10px;
  font-size: 14px;
  border: 1px solid #f2f2f2;
  border-radius: 15px;
  color: #fff;
  @media (max-width: 768px) {
    display: none;
  }
`

export const LSVideoPartSingleText = styled.div`
  font-size: 16px;
  ${(props) => props?.underline && 'text-decoration: underline;'};
  font-weight: 600;
`

export const LSNotesPartContainer = styled.div`
  width: 100%;
  height: 100%;
`

export const LSNotesContainerParent = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 7px;
  background: #78978e;
  position: relative;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  min-height: 300px;
`

export const LSNotesContainerHeading = styled.div`
  width: 100%;
  padding: 10px 25px;
  background: rgb(236 225 255);
  color: #000;
  font-weight: 500;
`

export const LSNotesContainerTextArea = styled.textarea`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: rgb(243 243 243);
  resize: none;
  color: #1f1f1f;
  padding: 20px 25px;
  font-size: 14px;
  font-weight: 400;

  :: -webkit-scrollbar {
    width: 5px;
  }

  :: -webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
  }

  :: -webkit-scrollbar-thumb {
    background: #3b4a46;
    border-radius: 5px;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
  // Hide/EDIT scrollbar for IE, Edge and Firefox
`

export const LSButton = styled.button`
  background: ${(props) => (props?.secondary ? 'transparent' : '#3b4a46')};
  border: 1px solid #3b4a46;
  border-radius: 39px;
  padding: 0 16px;
  height: 50px;
  min-width: 150px;
  color: ${(props) => (props?.secondary ? '#3b4a46' : '#fff')};
  font-size: 14px;
  font-weight: ${(props) => (props?.secondary ? '500' : '600')};
  display: flex;
  justify-content: center;
  align-items: center;
  &:disabled {
    background: #bbbdc3;
    border: #bbbdc3;
    color: #fff;
  }
  @media (min-width: 768px) {
    padding: 0 18px;
    font-size: 18px;
  }
  &:disabled {
    background: #bbbdc3;
    border: #bbbdc3;
  }
`

export const NotesSectionButton = styled.div`
  background: ${(props) => (props?.primary ? '#3b4a46' : '#fff')};
  border: ${(props) => (props?.primary ? 'none' : '1px solid #3b4a46')};
  border-radius: 39px;
  padding: 0 15px;
  color: ${(props) => (!props?.primary ? '#3b4a46' : '#fff')};
  font-size: 14px;
  font-weight: 600;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 35px;
  @media (min-width: 768px) {
    font-size: 18px;
  }
`

const blinkKeyframe = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const SessionRecording = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  color: #fff;
  background: #000;
  border-radius: 15px;
  text-transform: uppercase;
  font-size: 14px;
  padding: 2px 10px;
`

export const RedCircle = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background: #f7392e;
  animation: ${blinkKeyframe} 1s infinite alternate; /* Apply the blinking animation */
`

export const NotesOverlayDrawer = styled(Drawer)`
  // backdrop-filter: blur(1px);
  background-color: rgba(106, 109, 210, 0.2);

  .MuiPaper-root {
    height: 100vh;
    width: 300px;
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
  }
`

export const LSSidebarAndContent = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

export const LSOfflineSidebarContainer = muiStyled('div')(
  ({ theme }) => `
  background: ${theme.palette.emrSidebar.default};
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #fff;
  width: 100px;
  align-items: center;
  padding: 50px 0;
  gap: 20px;
  z-index: 998;
  @media print {
    display: none;
  }
`,
)

export const LSMainContent = styled.div`
  display: flex;
  width: ${({ withoutSidebar }) => (!!withoutSidebar ? '100%' : 'calc(100% - 100px)')};
  margin: ${({ withoutSidebar }) => (!!withoutSidebar ? '0 auto' : 'unset')};
  min-height: ${({ withoutSidebar, sessionStarted }) => (!!withoutSidebar ? (sessionStarted ? 'calc(-146px + 100vh)' : 'auto') : 'unset')};
  @media print {
    width: 100%;
  }
`

export const NextSessionContainer = styled.div`
  max-width: 1200px;
  // background: #fff;
  // border: 1px solid #efefef;
  border-radius: 10px;
  padding: 10px;
  color: #000;
  font-weight: 600;
  margin-bottom: 5px;
  cursor: pointer;
`

function getActivityPlanTableRowBackground(theme, header, index) {
  if (header) {
    return '#6a70d6'
  }
  if (index % 2 !== 0) {
    return '#eaeaea'
  }
}

export const LSActivityPlanTableContainer = muiStyled('div')(
  ({ theme }) => `
  overflow-x: auto;
  border-radius: 7px;
`,
)

export const LSActivityPlanTableRows = muiStyled('div')(
  ({ theme, header, index }) => `
  min-width: 768px;
  font-family: Outfit !important;
  display: grid;
  grid-template-columns: 90px 2fr 3fr 1fr 3fr 2fr;
  background: ${getActivityPlanTableRowBackground(theme, header, index)};
  font-weight: ${header ? '600' : '400'};
  border-bottom: 1px solid #00000036;
  padding: 10px 0px;
  color: ${header ? 'white' : 'unset'};
`,
)

export const LSActivityPlanContainerParent = muiStyled('div')(
  ({ theme }) => `
  padding: 0px 20px;
`,
)

export const LSActivityPlanContainerHeading = muiStyled('div')(
  ({ theme }) => `
  font-size: 35px;
  font-weight: 600;
  @media(min-width: 768px) {
  }
`,
)

export const LSActivityPlanCells = muiStyled('div')(
  ({ theme, actionButton }) => `
      padding: 0px 10px;
      align-items: center;
      display: flex;
      overflow: hidden;
  ${
    actionButton
      ? `
      display: flex;
      justify-content: flex-end;
      align-items: center;
      position: sticky;
      right: 0px;
      background: inherit;
  `
      : ''
  }
`,
)

export const EllipsisText = muiStyled('span')(
  ({ theme }) => `
      text-overflow: ellipsis;
      overflow: hidden;
      text-wrap: nowrap;`,
)

export const LSActivityPlanItemsContainer = muiStyled('div')(
  ({ theme }) => `
`,
)

export const AssignButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  font-family: Outfit!important;
  padding: 6px 10px;
  position: relative;
  background: #6a70d6;
  color: #fff;
  border-radius: 7px;
  @media(min-width: 576px) {
  padding: 6px 20px;
  }
`,
)

export const LSActivityPlanFilterContainer = muiStyled(Grid)(
  ({ theme }) => `
  font-family: Outfit !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
  background: ${theme.palette.background.paper};
  border-radius: 10px;
`,
)

export const LSActivityPlanDescriptionTooltipText = muiStyled('span')(
  ({ theme }) => `
  font-family: Outfit!important;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 10px;
`,
)

export const LSPlanOfferDialog = muiStyled(Paper)(
  ({ theme }) => `
  background: ${theme.palette.background.paper};
  border-radius: 10px;
`,
)

export const LSPlanOfferCancelButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  padding: 6px 10px;
  border-radius: 7px;
  font-family: Outfit!important;
`,
)

export const LSPlanOfferAcceptButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  padding: 6px 10px;
  background: #6a70d6;
  border-radius: 7px;
  color: #fff;
  font-family: Outfit!important;
`,
)

export const LSPlanBeingSentModalTitle = muiStyled('div')(
  ({ theme }) => `
  font-family: Outfit !important;
  font-size: 16px;

`,
)
export const LSPlanBeingSentModalDescription = muiStyled('div')(
  ({ theme }) => `
  font-family: Outfit !important;
  font-size: 14px;

`,
)
export const LSPlanBeingSentModalTotalDays = muiStyled('div')(
  ({ theme }) => `
  font-family: Outfit !important;
  font-size: 14px;

`,
)

export const LSPlanBeingSentModalContent = muiStyled(DialogContent)(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  gap: 10px;
`,
)

export const LSPlanBeingSentModalDialogTitle = muiStyled(DialogTitle)(
  ({ theme }) => `
  font-family: Outfit!important;
  font-size: 25px;
  font-weight: 600;
`,
)

export const LSGetPlanDialog = muiStyled(Dialog)(
  ({ theme }) => `
  z-index: 1200;
`,
)

export const StartingCircularProgress = muiStyled(CircularProgress)`
  color: #9F8CA6FF;
`

export const MicCameraToggleContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: ${(props) => {
    // Calculate button size based on icon size (button should be ~1.7x icon size)
    const iconSize = props?.iconSize || '28px'
    const sizeValue = parseFloat(iconSize)
    const sizeUnit = iconSize.replace(/[0-9.]/g, '')
    return `${(sizeValue * 1.7).toFixed(0)}${sizeUnit}`
  }};
  width: ${(props) => {
    const iconSize = props?.iconSize || '28px'
    const sizeValue = parseFloat(iconSize)
    const sizeUnit = iconSize.replace(/[0-9.]/g, '')
    return `${(sizeValue * 1.7).toFixed(0)}${sizeUnit}`
  }};
  border: 2px solid ${(props) => (props?.isActive ? '#ffffff' : '#ea4335')};
  background: ${(props) => (props?.isActive ? 'rgba(255, 255, 255, 0.2)' : 'rgba(234, 67, 53, 0.9)')};
  border-color: ${(props) => (props?.isActive ? '#ffffff' : '#ea4335')};
  color: ${(props) => (props?.isActive ? '#ffffff' : '#FFF')};
  transition: all 0.2s ease-in-out;
  font-size: 20px;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  @media (min-width: 768px) {
    height: ${(props) => {
      const iconSize = props?.iconSize || '28px'
      const sizeValue = parseFloat(iconSize)
      const sizeUnit = iconSize.replace(/[0-9.]/g, '')
      // Desktop: slightly larger multiplier
      return `${(sizeValue * 1.9).toFixed(0)}${sizeUnit}`
    }};
    width: ${(props) => {
      const iconSize = props?.iconSize || '28px'
      const sizeValue = parseFloat(iconSize)
      const sizeUnit = iconSize.replace(/[0-9.]/g, '')
      return `${(sizeValue * 1.9).toFixed(0)}${sizeUnit}`
    }};
  }
  &:hover {
    background: ${(props) => (props?.isActive ? 'rgba(255, 255, 255, 0.3)' : 'rgba(234, 67, 53, 1)')};
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.5), 0 3px 6px rgba(0, 0, 0, 0.4);
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
  }
`

export const AddtoCalendarStyledButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  padding: 6px 10px;
  background: #FFF;
  border-radius: 7px;
  color: #000;
  font-family: Outfit !important;
  display: flex;
  gap: 3px;
  font-weight: 400 !important;
  background: #f1e9c9;
  `,
)

export const LSPlanShowDrawerPaperProps = {
  maxWidth: '1200px',
}

export const LSPageInteractionPart = styled.div`
  height: 100%;
  width: ${(props) => (props?.big ? '650px' : '200px')};
  flex-shrink: 0;
  overflow: scroll;
  padding: 10px;
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const LSPageImmediateVideoCallContainer = styled.div`
  display: flex;
  width: 100%;
  height: ${({ isFullHeight }) => (isFullHeight ? '100vh' : 'calc(100vh - 60px)')};
  max-height: ${({ isFullHeight }) => (isFullHeight ? '100vh' : 'calc(100vh - 60px)')};
  overflow: hidden;
  position: relative;
  @media print {
    display: none;
  }
`

export const DrawerForOtherItemsOnMobile = styled(Drawer)`
  display: flex;
  justify-content: center;
  background-color: rgba(106, 109, 210, 0.2);
  .MuiPaper-root {
    height: 95vh;
    width: 95%;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
    background: #ffffff;
    background-size: 100% 100%;
    border: 1px solid #ffffff;
    border-radius: 4px 4px 0px 0px;
    overflow: hidden;
    overflow-y: auto; /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
      display: none;
    }
  }
`
export const LSPastReportsSkeleton = styled(Skeleton)(
  ({ theme }) => `
  background:rgb(0 0 0 / 10%);
`,
)

export const LSRightContentContainer = muiStyled('div')(
  ({ theme, hasVideoCall, sessionStarted }) => `
            width: ${hasVideoCall ? '50%' : '100%'};
            height: ${hasVideoCall && sessionStarted ? '100%' : 'auto'};
            max-height: ${hasVideoCall && sessionStarted ? 'calc(100vh - 108px)' : 'none'};
            min-height: auto;
            display: flex;
            overflow-y: ${hasVideoCall && sessionStarted ? 'auto' : 'visible'};
            overflow-x: hidden;
            flex-direction: column;
            flex-shrink: 0;
            @media print {
              overflow-y: unset;
              width: 100%;
              height: auto;
              max-height: none;
            }
`,
)
